"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = exports.Language = void 0;
// 语种
var Language;
(function (Language) {
    // 英文
    Language["EN"] = "en";
    // 简体
    Language["SC"] = "sc";
    // 繁体
    Language["TC"] = "tc";
    // 日语
    Language["JP"] = "jp";
})(Language || (exports.Language = Language = {}));
// 应用列表
var Channel;
(function (Channel) {
    // 系统分享
    Channel["SYSTEM"] = "system";
    // reddit
    Channel["REDDIT"] = "reddit";
    // fb
    Channel["FACEBOOK"] = "facebook";
    // telegram
    Channel["TELEGRAM"] = "telegram";
    // 小红书
    Channel["XIAOHONGSHU"] = "xiaohongshu";
    // tw
    Channel["TWITTER"] = "twitter";
    // ins
    Channel["INSTAGRAM"] = "instagram";
    // whatsapp
    Channel["WHATSAPP"] = "whatsapp";
    // wxFriend: 微信好友
    Channel["WXFRIEND"] = "wxFriend";
    // wxTimeline: 微信朋友圈
    Channel["WXTIMELINE"] = "wxTimeline";
    // 复制链接
    Channel["COPY"] = "copy";
    // line
    Channel["LINE"] = "line";
})(Channel || (exports.Channel = Channel = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsS0FBSztBQUNMLElBQVksUUFTWDtBQVRELFdBQVksUUFBUTtJQUNoQixLQUFLO0lBQ0wscUJBQVMsQ0FBQTtJQUNULEtBQUs7SUFDTCxxQkFBUyxDQUFBO0lBQ1QsS0FBSztJQUNMLHFCQUFTLENBQUE7SUFDVCxLQUFLO0lBQ0wscUJBQVMsQ0FBQTtBQUNiLENBQUMsRUFUVyxRQUFRLHdCQUFSLFFBQVEsUUFTbkI7QUFlRCxPQUFPO0FBQ1AsSUFBWSxPQXlCWDtBQXpCRCxXQUFZLE9BQU87SUFDZixPQUFPO0lBQ1AsNEJBQWlCLENBQUE7SUFDakIsU0FBUztJQUNULDRCQUFpQixDQUFBO0lBQ2pCLEtBQUs7SUFDTCxnQ0FBcUIsQ0FBQTtJQUNyQixXQUFXO0lBQ1gsZ0NBQXFCLENBQUE7SUFDckIsTUFBTTtJQUNOLHNDQUEyQixDQUFBO0lBQzNCLEtBQUs7SUFDTCw4QkFBbUIsQ0FBQTtJQUNuQixNQUFNO0lBQ04sa0NBQXVCLENBQUE7SUFDdkIsV0FBVztJQUNYLGdDQUFxQixDQUFBO0lBQ3JCLGlCQUFpQjtJQUNqQixnQ0FBcUIsQ0FBQTtJQUNyQixvQkFBb0I7SUFDcEIsb0NBQXlCLENBQUE7SUFDekIsT0FBTztJQUNQLHdCQUFhLENBQUE7SUFDYixPQUFPO0lBQ1Asd0JBQWEsQ0FBQTtBQUNqQixDQUFDLEVBekJXLE9BQU8sdUJBQVAsT0FBTyxRQXlCbEIifQ==